import {

    FETCH_EVENTVENDORS_DATA_ACTION_FULFILLED,
    FETCH_EVENTVENDORS_DATA_ACTION_PENDING,
    FETCH_EVENTVENDORS_DATA_ACTION_REJECTED,

    FETCH_EVENTCONTENTSIZE_DATAINFO_ACTION_FULFILLED,
    FETCH_EVENTCONTENTSIZE_DATAINFO_ACTION_PENDING,
    FETCH_EVENTCONTENTSIZE_DATAINFO_ACTION_REJECTED,

    UPDATE_USER_FILTER_ACTION_FULFILLED,
    UPDATE_USER_FILTER_ACTION_PEDING,
    UPDATE_USER_FILTER_ACTION_REJECTED


} from '../actions/eventvendors.action'

const initialState = {
    isLoading: false,
    isLoaded: false,
    data_info: [], // give the size etc
    data: [], // give the real data
    filter_bool_info: false,
}

//rmb to unwrap to the point where the basic data structure expose
export default (state = initialState, action) => {
    switch (action.type) {


        case FETCH_EVENTCONTENTSIZE_DATAINFO_ACTION_FULFILLED:
            return {
                ...state,
                data_info: action.payload.data.data,
                isLoading: false,
                isLoaded: true,
            }
        case FETCH_EVENTCONTENTSIZE_DATAINFO_ACTION_PENDING:
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
            }
        case FETCH_EVENTCONTENTSIZE_DATAINFO_ACTION_REJECTED:
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
            }


        case FETCH_EVENTVENDORS_DATA_ACTION_FULFILLED:
            return {
                ...state,
                data: action.payload.data.data,
                isLoading: false,
                isLoaded: true,

            }
        case FETCH_EVENTVENDORS_DATA_ACTION_PENDING:
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
            }
        case FETCH_EVENTVENDORS_DATA_ACTION_REJECTED:
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
            }



        case UPDATE_USER_FILTER_ACTION_FULFILLED:
            return {
                ...state,
                filter_bool_info: action.payload.data,
                isLoading: false,
                isLoaded: true,

            }
        case UPDATE_USER_FILTER_ACTION_PEDING:
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
            }
        case UPDATE_USER_FILTER_ACTION_REJECTED:
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
            }

        default:
            return state


    }
}